import { Fragment, useRef, useState } from 'react';

import Button from '@mui/material/Button';

import { ShareIssueButtonMenu } from 'components/Menu';
import logger from 'utils/logger';
import Icon from 'components/Icon';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';

const log = logger.createLogger('ShareIssueButton');

const ShareIssueButton = ({
  setIssueShareConfirmModalOpen,
  shareIssueConfirmModalBodyText,
  shareIssueConfirmFunc,
  shareIssueCancelFunc,
  shareIssueServiceType,
  ...buttonProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  return (
    <Fragment>
      <div ref={buttonRef}>
        <Button
          startIcon={<Icon type="feedback" />}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '32px',
            verticalAlign: 'middle',
            lineHeight: 1,
            padding: '0 12px',
            whiteSpace: 'nowrap',
            borderRadius: '3px',
            fontSize: '14px',
            transition: 'all 0.1s',
            backgroundColor: '#fff',
            color: '#636363',
          }}
          onClick={handleClick}
          variant="text"
          {...buttonProps}>
          {intl.get('shared_value_share')}
        </Button>
      </div>
      <ShareIssueButtonMenu
        key={`menu-${open}`}
        anchorEl={anchorEl}
        data-test-id="share-issue-button"
        open={open}
        onClose={handleClose}
        setIssueShareConfirmModalOpen={setIssueShareConfirmModalOpen}
        shareIssueConfirmModalBodyText={shareIssueConfirmModalBodyText}
        shareIssueConfirmFunc={shareIssueConfirmFunc}
        shareIssueCancelFunc={shareIssueCancelFunc}
        shareIssueServiceType={shareIssueServiceType}
      />
    </Fragment>
  );
};

ShareIssueButton.propTypes = {
  setIssueShareConfirmModalOpen: PropTypes.func.isRequired,
  shareIssueConfirmModalBodyText: PropTypes.object.isRequired,
  shareIssueConfirmFunc: PropTypes.object.isRequired,
  shareIssueCancelFunc: PropTypes.object.isRequired,
  shareIssueServiceType: PropTypes.string.isRequired,
};

export default ShareIssueButton;
